import React from 'react'

type ImgCache = {
  __cache: { [key: string]: boolean | Promise<boolean | void> }
  read: (src: string) => boolean | Promise<boolean | void>
}

const imgCache: ImgCache = {
  __cache: {},
  read(src: string) {
    // An empty src fires no load event at all, so suspending on it would leave
    // the caller's fallback on screen permanently.
    if (!src) {
      return true
    }
    if (!this.__cache[src]) {
      this.__cache[src] = new Promise((resolve) => {
        const img = new Image()
        img.onload = () => resolve(true)
        // onerror matters as much as onload. Without it a 404 or an expired
        // presigned URL leaves this promise unsettled forever, and Suspense
        // keeps showing the loading fallback instead of the image or an error.
        img.onerror = () => resolve(true)
        img.src = src
      }).then(() => {
        this.__cache[src] = true
      })
    }
    if (this.__cache[src] instanceof Promise) {
      throw this.__cache[src]
    }
    return this.__cache[src]
  },
}

export interface SuspenseImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string
}

export const SuspenseImage: React.FC<SuspenseImageProps> = ({ src, ...rest }) => {
  imgCache.read(src)
  return <img src={src} {...rest} />
}

export default SuspenseImage
